module.exports = __webpack_public_path__ + "xi_text.f5d79d85.png";